import type { Dictionary } from '@types'

import getDictionary from '@lib/helpers/cross-env/get-dictionary'
import determineCountry from '@lib/helpers/cross-env/determine-country'

const useI18n = (): Dictionary => {
  const locale = determineCountry()
  return getDictionary(locale)
}

export default useI18n
